export interface DemoConfig {
  title: string;
  industry: string;
  description: string;
  type: 'customgpt' | 'fastbots' | 'video';
  config: {
    projectId?: string;
    projectKey?: string;
    botId?: string;
    youtubeId?: string;
  };
}

// Demo configuration with YouTube videos for different industries
export const DEMO_CONFIGS: Record<string, DemoConfig> = {
  // Healthcare & Wellness
  'healthcare-acupuncture': {
    title: 'Acupuncture Clinic',
    industry: 'Healthcare',
    description:
      'Watch an AI agent handle clinic FAQs, pricing, and booking questions, trained on your content, not guesswork.',
    type: 'video',
    config: {
      youtubeId: '6A-fowbpyRY',
    },
  },
  'mental-health-counseling': {
    title: 'Counseling Practice',
    industry: 'Mental Health',
    description:
      'See an AI agent answer therapy FAQs with care, route intake questions, and help visitors book the right next step.',
    type: 'video',
    config: {
      youtubeId: 'a-nkqx2znBw',
    },
  },

  // Religious Organizations
  'church-ministry': {
    title: 'Church Ministry',
    industry: 'Religious Organizations',
    description:
      'See an AI agent answer ministry questions, share service info, and help visitors take next steps, fast and accurate.',
    type: 'video',
    config: {
      youtubeId: 'Aj67LLjHGgo',
    },
  },

  // Lawn Care & Landscaping
  'lawn-care-maintenance': {
    title: 'Lawn Maintenance',
    industry: 'Lawn Care',
    description:
      'See an AI agent answer service questions, route inquiries, and book estimates, built for local lawn businesses.',
    type: 'video',
    config: {
      youtubeId: 'gsq-9x-mMG4',
    },
  },
  'lawn-care-irrigation': {
    title: 'Lawn Care & Irrigation',
    industry: 'Lawn Care',
    description:
      'See an AI agent quote services, explain packages, and capture leads for lawn care and irrigation websites.',
    type: 'video',
    config: {
      youtubeId: 'yjVc0yN-4PU',
    },
  },

  // Beauty & Personal Care
  'salon-services': {
    title: 'Salon Services',
    industry: 'Beauty & Personal Care',
    description:
      'See an AI agent answer service and pricing questions, recommend appointments, and capture booking intent.',
    type: 'video',
    config: {
      youtubeId: 'dz0kqT1_arQ',
    },
  },

  // Restaurant & Food Service
  'restaurant-pizza': {
    title: 'Restaurant & Pizza',
    industry: 'Restaurant',
    description:
      'See an AI agent answer menu questions, hours, and catering inquiries, helping diners convert faster.',
    type: 'video',
    config: {
      youtubeId: 'too59Tq2xUE',
    },
  },
};

export function getDemoConfig(slug: string): DemoConfig | null {
  return DEMO_CONFIGS[slug] || null;
}
